import React from 'react';
import Grid from '@/components/molecules/Grid';
import { ModalTitle } from '@/components/atoms/UI/Modal/styles';
import { useTranslation } from 'react-i18next';
import Item from '@/components/atoms/UI/Item/Item';
import { useSelector } from 'react-redux';
import LoadingErrorHandler from '@/components/templates/LoadingErrorHandler';
import { selectHistoryItems } from '@/store/selectors/resultHistorySelector';
import { selectAttemptKey } from '@/store/selectors/selectAttemptKey';

interface ResultHistoryProps {
    error: string | null;
    isFetching: boolean;
    isNetworkError: boolean;
    onReload: () => void; // Функция для повторной загрузки
}

const ResultHistory: React.FC<ResultHistoryProps> = ({
                                                         error,
                                                         isFetching,
                                                         isNetworkError,
                                                         onReload,
                                                     }) => {
    const historyItems = useSelector(selectHistoryItems);
    const attemptKey = useSelector(selectAttemptKey);

    const { t } = useTranslation();
    const text_title = t('result.my_results');

    return (
        <Grid col="1" gap="3" centeredContent>
            <ModalTitle>{text_title}</ModalTitle>
            <LoadingErrorHandler
                error={error}
                isFetching={isFetching}
                onReload={onReload}
                isNetworkError={isNetworkError}
            >
                <Grid col="1" gap="2">
                    {historyItems.map((item) => (
                        <Item
                            className={item.key === attemptKey ? 'active' : ''}
                            key={item.key}
                            href={item.url}
                        >
                            <b>№ {item.num}</b> {item.created_at}
                        </Item>
                    ))}
                </Grid>
            </LoadingErrorHandler>
        </Grid>
    );
};

export default ResultHistory;
